var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPriorityIcon = function SvgPriorityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3000_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21L11.99 20.999C16.96 20.999 20.99 16.969 20.99 11.999C20.99 7.01897 16.96 2.99897 11.99 2.98897C7.01 2.97897 2.99 7.00897 2.98 11.979V11.969C2.97 16.939 7 20.969 11.97 20.969L12 21Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 10.2L12 8.39996L13.8 10.2",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 13.8L12 15.6L13.8 13.8",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3000_479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgPriorityIcon as ReactComponent };
export default __webpack_public_path__ + "priority-icon.svg";